/** Allowed CSS custom property names for brand overrides — accent-only tokens */
export const ALLOWED_BRAND_OVERRIDES = new Set([
  '--color-primary',
  '--color-primary-hover',
]);

/**
 * Injection defense — NOT a semantic color validator.
 * Rejects values containing url(), expression(), behavior(), semicolons, or braces.
 * Non-color strings that pass validation will be ignored by CSS or render oddly;
 * clients must provide valid CSS color values (hex, rgb(), hsl(), oklch(), etc.).
 * @param {string} _key
 * @param {string} value
 * @returns {boolean}
 */
export function isValidBrandValue(_key, value) {
  if (typeof value !== 'string') return false;
  if (value.length > 100) return false;
  const lower = value.toLowerCase();
  if (/[;{}]/.test(lower)) return false;
  if (/url\s*\(/.test(lower)) return false;
  if (/expression\s*\(/.test(lower)) return false;
  return true;
}
